<template>
  <div id="container">
      <Spinner :show="loading"></Spinner>
      <Header></Header>
      <Modal v-if="modal.title" :title="modal.title" :body="modal.body" :centerBody="modal.centerBody" :className="modal.className" :buttons="modal.buttons"></Modal>
      <!-- <AddressBook ref="addressBook"></AddressBook> -->
      <section ref="content" id="content" class="section">
          <Notification v-if="notification.show" :text="notification.text" :className="notification.className"></Notification>
          <div class="relative has-text-centered">
            <div ref="step1" class="absolute full-width">
                <label class="label">Enter the account number of the household meter you want to send credit to</label>
                <div class="columns is-mobile is-centered">
                    <div class="column is-full">
                        <div class="control has-icons-left has-icons-right">
                            <input ref="accountNumber" @click="hideTabs()" @focus="hideTabs()" @blur="showTabs()" v-model="accountNumber" class="input" type="text" autocomplete="off" :placeholder="$t('AccountNumber')" required>
                            <span class="icon is-small is-left">
                                <i class="fa fa-tint"></i>
                                <!-- <i @click="showContacts()" class="fa fa-address-book clickable"></i> -->
                            </span>
                        </div>
                    </div>
                </div>
                <div class="columns is-mobile is-centered">
                    <div class="column is-half has-text-centered">
                        <a @click="next()" class="button is-primary is-fullwidth">
                            <span class="icon">
                                <i class="fa" :class="[loading ? 'fa-spinner fa-spin' : 'fa-arrow-right']"></i>
                            </span>
                            <span>{{ $t("Next") }}</span>
                        </a>
                    </div>
                    <div class="column is-half has-text-centered">
                        <a @click="$router.go(-1)" class="button is-info is-fullwidth">
                            <span class="icon">
                                <i class="fa fa-times"></i>
                            </span>
                            <span>{{ $t("Cancel") }}</span>
                        </a>
                    </div>
                </div>
                <div class="columns is-mobile is-centered">
                    <div class="column is-full has-text-centered">
                        <a @click="$router.push('/wallet/send')" class="button is-primary is-fullwidth">
                            <span class="icon">
                                <i class="fa fa-exchange"></i>
                            </span>
                            <span>{{ $t("SendToWallet") }}</span>
                        </a>
                    </div>
                </div>
                <div class="columns is-mobile is-centered">
                    <div class="column is-full has-text-centered">
                        <a @click="$router.push('/tag/topup')" class="button is-info is-fullwidth">
                            <span class="icon">
                                <i class="fa fa-tag"></i>
                            </span>
                            <span>{{ $t("SendToTag") }}</span>
                        </a>
                    </div>
                </div>
            </div>
            <div ref="step2" class="absolute full-width is-hidden">
                <div class="columns is-mobile is-centered">
                    <div class="column is-full has-text-centered">
                        <div class="field">
                            <label class="label">{{ $t("SendTo") }} </label>
                            <div class="control has-icons-left">
                                <input class="input" v-model="recipient" type="text" disabled readonly>
                                <span class="icon is-small is-left">
                                    <i class="fa fa-tint"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns is-mobile is-centered">
                    <div class="column is-full has-text-centered">
                        <div class="field">
                            <label class="label">{{ $t("Amount") }}</label>
                            <div class="control has-icons-left">
                                <input ref="amount" @click="hideTabs()" @focus="hideTabs()" @blur="showTabs()" class="input" type="number" :placeholder="$t('Amount')" required v-model.number="amount" :min="minTransfer">
                                <span v-html="user.wallet.currency.symbol" class="icon is-small is-left"></span>
                            </div>
                        </div>
                        <div>{{ $t("MinimumTransferBody", [this.showCurrency(minimumTransferCredits, user.wallet.currency)]) }}</div>
                    </div>
                </div>
                <div class="columns is-mobile is-centered">
                    <div class="column is-half has-text-centered">
                        <a @click="send()" class="button is-primary is-fullwidth">
                            <span class="icon">
                                <i class="fa fa-exchange"></i>
                            </span>
                            <span>{{ $t("Send") }}</span>
                        </a>
                    </div>
                    <div class="column is-half has-text-centered">
                        <a @click="back()" class="button is-info is-fullwidth">
                            <span class="icon">
                                <i class="fa fa-arrow-left"></i>
                            </span>
                            <span>{{ $t("Back") }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
      </section>
  <NavigationTabs></NavigationTabs>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Modal from "@/components/Modal.vue";
// import AddressBook from "@/components/AddressBook.vue";
import Notification from "@/components/Notification.vue";
// import QrScanner from "@/components/QrScanner.vue";
import NavigationTabs from "@/components/NavigationTabs.vue";
import Spinner from "@/components/Spinner.vue";

export default {
  name: "MeterTopup",
  components: {
    Header,
    Modal,
    // AddressBook,
    Notification,
    // QrScanner,
    NavigationTabs,
    Spinner
  },
  props:
  {
    _accountNumber: Number,
    _amount: String,
    _currency: String
  },
  async mounted() {
    this.minTransfer = parseFloat(this.showCurrency(this.minimumTransferCredits, this.user.wallet.currency));
    this.amount = this.minTransfer;

    if(this._amount && this._currency)
    {
        const response = await this.$http.get(`/Utilities/LocalCurrency?amount=${this._amount}&currencyCode=${this._currency}`);
        this.amount = response.data.amount;
    }

    if(this._accountNumber)
    {
        this.next();
    }

    await this.updateUser();
  },
  computed:
  {
    recipient: function()
    {
        return `${this.meter.accountNumber} (${this.meter.name})`;
    }
  },
  data () {
      return {
          minimumTransferCredits: 3000,
          accountNumber: this._accountNumber,
          meter: {},
          assets: [],
          minTransfer: 0,
          amount: 0,
          modal: {
              title: null,
              body: null,
              centerBody: true,
              className: "",
              buttons: []
          }
      }
  },
  methods:
  {
      back: function() {
        this.$refs[`step${this.step}`].classList.remove("is-hidden");
        this.$refs[`step${this.step+1}`].classList.add("is-hidden");
      },
      next: async function() {
        if(!this.$refs.accountNumber.checkValidity())
        {
            this.$refs.accountNumber.reportValidity();
            return;
        }

        try
        {
            const response = await this.$http.get(`/Household/Meter?accountNumber=${this.accountNumber}`);
            this.meter = response.data;
            this.$refs.step1.classList.add("is-hidden");
            this.$refs.step2.classList.remove("is-hidden");
        }

        catch(error)
        {
            alert(this.$t("UnknownMeter"));
        }
      },
      send: function() {
        const amount = parseFloat(this.amount);

        if (isNaN(amount) || amount < parseFloat(this.minTransfer)) {
            this.$refs.amount.reportValidity();
            return;
        }

        this.modal.title = this.$t("ConfirmTransfer");
        this.modal.body = `<p>${this.$t("ConfirmTransferBody", {amount: this.formatCurrency(this.amount, this.user.wallet.currency), recipient: this.recipient})}</p>`;
        
        this.modal.buttons =
        [
            {id: 0, title: this.$t("Yes"), className: "is-primary", click: this.doSend},
            {id: 1, title: this.$t("No"), className: "is-info", click: () => { this.modal.className = ""; }}
        ];

        this.modal.className = "is-active";
      },
      doSend: async function()
      {
        if(this.loading)
        {
            return;
        }

        try
        {
            const response = await this.$http.put(`/Transactions`,
            [
                {
                    currencyCode: this.user.wallet.currency.code,
                    amount: this.amount,
                    accountNumber: this.accountNumber
                }
            ]);

          console.dir(response);
          if (response.status < 200 || response.status > 299){ // failure of some kind
            this.$refs.content.scrollTo(0, 0);
            this.modal.className = "";
            this.notification = {
              show: true, className: "is-danger",
              text: response.data.message || this.$t("Error")
            }
          } else { // Success

            this.modal.className = "is-active";
            this.modal.title = this.$t("CreditSent");
            this.modal.body = this.$t("CreditSentBody", [this.formatCurrency(this.amount, this.user.wallet.currency), this.recipient]).split("\\n").join("<br><br>");

            this.modal.buttons =
                [
                  {
                    id: 0, title: this.$t("Yes"), className: "is-primary", click: function () {
                      this.$router.go()
                    }.bind(this)
                  },
                  {
                    id: 1, title: this.$t("No"), className: "is-info", click: function () {
                      this.$router.push("/wallet/transactions")
                    }.bind(this)
                  }
                ]

            await this.updateUser();
          }
        } catch (error) {
          console.dir(error);
          this.$refs.content.scrollTo(0, 0);
          this.modal.className = "";

          if (error.response) {
            this.notification =
                {
                  show: true,
                  className: "is-danger",
                  text: error.response.data.message
                }
          } else {
            this.notification =
                {
                  show: true,
                  className: "is-danger",
                  text: error.message || this.$t("Error")
                }
          }
        }
      }
  }
};
</script>
